export default __webpack_public_path__ + "static/media/Britt.8ae02515.jpeg";